import React, { useState } from "react";
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';

export const Others = (props) => {
 
  const contactInfo = props.contactData;
 
  return (
    <>
      <div id="contacts" className="mainContentData">
        <br></br>
        <div className="col-lg-12 px-0">
          <div className="row m-0">
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium custom-font-size">
                  Other Details
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 px-0">
          <div className="row m-0">
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium">Anniversary</span>
                <p className="fw-medium mb-0">
                  {contactInfo.anniversary ? moment(contactInfo.anniversary).format("MM/DD/yyyy") : "-"}
                </p>
              </div>
              <br></br>
              <div className="mb-4">
                <span className="fw-medium">Estimated Assets</span>
                <p className="fw-medium mb-0">
                  {contactInfo.estimateAssest || "-"}
                </p>
              </div>
              <br></br>
              <div className="mb-4">
                <span className="fw-medium">Sits on Board</span>
                <div className="mb-4">
                  <input
                    type="checkbox"
                    className="mb-0"
                    checked={contactInfo.boardMember === "Yes"}
                  />
                </div>
              </div>
              <br></br>
            </div>
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium">Spouse Name</span>
                <p className="fw-medium mb-0">
                  {contactInfo.spouseName || "-"}
                </p>
              </div>
              <br></br>
              <div className="mb-4">
                <span className="fw-medium">Web User ID</span>
                <p className="fw-medium mb-0">{contactInfo.webUserId || "-"}</p>
              </div>
              <br></br>
              <div className="mb-4">
                <span className="fw-medium">Estimated Annual Income</span>
                <p className="fw-medium mb-0">{contactInfo.annualIncome}</p>
              </div>
              <br></br>
            </div>
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium">Contact Source</span>
                <p className="fw-medium mb-0">
                  {contactInfo.contactSource || "-"}
                </p>
              </div>
              <br></br>
              <div className="mb-4">
                <span className="fw-medium">Web Status</span>
                <p className="fw-medium mb-0">
                  {contactInfo.contactWebStatusTypeName || "-"}
                </p>
              </div>
              <br></br>
              <div className="mb-4">
                <span className="fw-medium">Last Modified</span>
                <p className="fw-medium mb-0">
                  {moment(contactInfo.modifiedDate).format("MM/DD/YYYY")}
                </p>
              </div>
              <br></br>
            </div>
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium">Web Category</span>
                <p className="fw-medium mb-0">
                  {contactInfo.contactWebCategoryName || "-"}
                </p>
              </div>
              <br></br>
              <div className="mb-4">
                <span className="fw-medium">Web URL</span>
                <p className="fw-medium mb-0">{contactInfo.webUrl || "-"}</p>
              </div>
              <br></br>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer/>
    </>
  );
};
